import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';

import { BoxFlex, RadioCard } from '@woovi/ui';

type PaymentCardProps = {
  children?: ReactElement;
  value: unknown;
  installment: {
    number: number;
    value: string;
  };
  method: string;
};

const PaymentCard = ({
  value,
  installment,
  children,
  method,
}: PaymentCardProps) => (
  <RadioCard
    cardProps={{
      sx: {
        flex: 1,
      },
    }}
    value={value}
    radioTestId={`payment-card-${method}-${value}`}
  >
    <Typography sx={{ fontSize: 20 }}>
      <span style={{ fontWeight: 'bold' }}>{installment.number}x</span>{' '}
      {installment.value}
    </Typography>
    <BoxFlex sx={{ flexDirection: 'column', mt: 1 }}>{children}</BoxFlex>
  </RadioCard>
);

export default PaymentCard;
